// utils/getUserId.js
// Robust utility to get user ID from multiple sources

import { getSecureItem } from './encryption';

/**
 * Get user ID from the most reliable source available
 * Priority: window.uId > encrypted localStorage
 * 
 * SECURITY: Only uses encrypted storage, no plain text fallback
 */
export const getUserId = () => {
  // First try window.uId (most reliable, always available in memory)
  if (window.uId) {
    return window.uId;
  }

  // Try to get from encrypted storage
  try {
    const appState = getSecureItem('p10-app-state');
    if (appState && appState.user?.id) {
      // Set window.uId for future use (in-memory only, not persisted)
      window.uId = appState.user.id;
      
      // Also set other user data in memory
      if (appState.user.first_name) window.uFirstName = appState.user.first_name;
      if (appState.user.last_name) window.uLastName = appState.user.last_name;
      if (appState.user.rating) window.uRating = appState.user.rating;
      if (appState.user.email) window.uEmail = appState.user.email;
      
      return appState.user.id;
    }
  } catch (error) {
    console.error('getUserId: Error reading encrypted storage:', error);
    console.error('getUserId: This may mean the encryption key was lost. User needs to sign in again.');
  }

  console.error('getUserId: No user ID found - user needs to sign in');
  return null;
};

/**
 * Ensure window.uId is set, try to restore from storage if missing
 * Returns true if userId is available, false otherwise
 */
export const ensureUserId = () => {
  const userId = getUserId();
  return userId !== null;
};

export default getUserId;